import { render, staticRenderFns } from "./TextTypeBox.vue?vue&type=template&id=1e444f44&scoped=true"
import script from "./TextTypeBox.vue?vue&type=script&lang=js"
export * from "./TextTypeBox.vue?vue&type=script&lang=js"
import style0 from "./TextTypeBox.vue?vue&type=style&index=0&id=1e444f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e444f44",
  null
  
)

export default component.exports